// extracted by mini-css-extract-plugin
export default {"container":"about_container__j0wlG","photo_container":"about_photo_container__iCU11","photo":"about_photo__ggwNF","content":"about_content__GHZcf"};